<template>
  <div style="min-height:600px; background-color: white">
    <a-breadcrumb style="padding: 16px 24px">
      <a-breadcrumb-item>
        <router-link :to="{name:'scf'}">
          <a-icon type="home"/>
          <span>首页</span>
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item href="">
        <span>{{ societyInfo.name }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>

    <a-page-header
      style="border: 1px solid rgb(235, 237, 240); text-align:center"
    >
      <h3 class="text-title">{{ societyInfo.name }}</h3>
      <a-descriptions size="small" :column="2">
        <a-descriptions-item label="">
          <a-icon type="team"></a-icon>
          {{ societyInfo.pageview }}
        </a-descriptions-item>
        <a-descriptions-item label="">
          <a-icon type="clock-circle"></a-icon>
          {{ societyInfo.addTime.split('T')[0]}}
        </a-descriptions-item>

      </a-descriptions>

    </a-page-header>

    <!--    <div  id="course-info" v-html="item.desc"></div>-->
    <div style="padding: 16px 24px">
      <div v-html="societyInfo.desc"></div>

      <a-divider/>

    </div>


  </div>
</template>

<script>
import {domain, getSocietyInfo} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";

export default {
  name: "societyInfo",
  props: {
    id: ''
  },
  data() {
    return {
      societyInfo: ''
    };
  },
  watch: {
    $route(to, from) {
      if ((to.name === from.name) && (to.path !== from.path)) {
        if (to.params.id !== from.params.id){
          this.id = to.params.id
          getSocietyInfo(this.id).then(res => {
            this.societyInfo = filterUnderLine(res.data);
            let w = window.screen.width;
            if(w<400){
              this.societyInfo.desc = this.societyInfo.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `${domain}` + '/scf_media')
            }else{
              this.societyInfo.desc = this.societyInfo.desc.replace(/<img src="\/scf_media/g, '<img src="' + `${domain}` + '/scf_media')
            }

          }).catch(err => {
            console.log(err)
          });
        }
      }

    }
  },
  mounted() {

    getSocietyInfo(parseInt(this.id)).then(res => {
      this.societyInfo = filterUnderLine(res.data)
      this.societyInfo.updateTime = this.societyInfo.updateTime.split('T')[0]
      let w = window.screen.width;
      if(w<400){
        this.societyInfo.desc = this.societyInfo.desc.replace(/<img src="\/scf_media/g, '<img width="100%" src="' + `${domain}` + '/scf_media')
      }else{
        this.societyInfo.desc = this.societyInfo.desc.replace(/<img src="\/scf_media/g, '<img src="' + `${domain}` + '/scf_media')
      }
    })


  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/content/SocietyInfo.vue